import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function TaskAssignee({ clientId, value, assigneeId, generic = [], onChange, t, testId, className }) {
  const [people, setPeople] = useState([]);
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let alive = true;
    setPeople([]); setFailed(false);
    if (!clientId) { setLoading(false); return () => { alive = false; }; }
    setLoading(true);
    api.get(`/tasks/assignees?client_id=${encodeURIComponent(clientId)}`)
      .then(r => { if (alive) setPeople(r.data); })
      .catch(() => { if (alive) setFailed(true); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [clientId]);
  const selected = assigneeId ? `user:${assigneeId}` : (value || "KEWAG Team");
  return <div className="min-w-0">
    <select aria-label={t("Zuständig")} data-testid={testId} className={className} value={selected}
      onChange={e => {
        const member = people.find(p => `user:${p.id}` === e.target.value);
        onChange(member ? { assignee_id: member.id, assignee: member.name } : { assignee_id: null, assignee: e.target.value });
      }}>
      <optgroup label={t("Team oder Kunde")}>
        {generic.map(a => <option key={a} value={a}>{t(a)}</option>)}
      </optgroup>
      {people.length > 0 && <optgroup label={t("Zuständige Person")}>
        {people.map(p => <option key={p.id} value={`user:${p.id}`}>{p.name}</option>)}
      </optgroup>}
      {!assigneeId && value && !generic.includes(value) && <option value={value} disabled>{value} · {t("Nicht verfügbar")}</option>}
      {assigneeId && !people.some(p => p.id === assigneeId) && <option value={selected} disabled>{value} · {t("Nicht verfügbar")}</option>}
    </select>
    <div className="min-h-[20px]">
    {!clientId && <p className="mt-1 text-xs text-gray-400">{t("Zuerst Kunde auswählen")}</p>}
    {loading && <p role="status" className="mt-1 text-xs text-gray-400">{t("Team wird geladen…")}</p>}
    {failed && <p role="alert" className="mt-1 text-xs text-amber-300">{t("Team konnte nicht geladen werden. Bitte erneut öffnen.")}</p>}
    </div>
  </div>;
}
